import { Controller } from "@hotwired/stimulus"

// One private note: its text and the inline edit form. "Edytuj" swaps the
// text for the form, "Anuluj" swaps back; the actions row hides while editing.
export default class extends Controller {
  static targets = ["view", "form", "actions"]

  toggle() {
    const formHidden = this.formTarget.classList.toggle("hidden")
    this.viewTarget.classList.toggle("hidden", !formHidden)
    if (this.hasActionsTarget) this.actionsTarget.classList.toggle("hidden", !formHidden)
    if (!formHidden) this.formTarget.querySelector("textarea")?.focus()
  }
}
